export const FORM_HEADER_PLACEHOLDER = 'Example Form';
